/* ds-image-translate.js – Ersatz für die App "EZ Product Translate" (Freshify).
   Gebaut 23.10.2026 (Claude, REA-Projekt). Logik 1:1 vom App-Skript (algo_deskspace.js, per REA ausgelesen):
   Bild-Dateiname normalisieren (_1800x, _{width}x, _small … entfernen) -> in der Tabelle der aktuellen Sprache
   nachschlagen -> src/srcset/data-src/data-photoswipe-src und Links auf /cdn/shop/ ersetzen.
   Unterschiede zur App: Tabelle liegt auf dem eigenen Shopify-CDN (nicht mehr beim Anbieter),
   deutsche Seiten laden gar nichts (Snippet bindet das Skript dort nicht ein). */
(function () {
  'use strict';
  var me = document.currentScript;
  var src = me && me.getAttribute('data-map');
  var lang = ((me && me.getAttribute('data-lang')) || '').toLowerCase();
  if (!src || !lang) return;

  function pick(all, key) {
    var t = all && all[key];
    return t && !Array.isArray(t) && Object.keys(t).length ? t : null;
  }
  function fileName(url) {
    if (!url || typeof url !== 'string') return null;
    if (url.indexOf('data:') === 0 || url.indexOf('blob:') === 0) return null;
    var seg = url.split('?')[0].split('/').pop() || '';
    try { seg = decodeURIComponent(seg); } catch (e) {}
    seg = seg.replace(/_\{width\}x(?=\.)/i, '')
             .replace(/_(small|medium|large|[0-9]+x(?:[0-9]+)?)(?=\.)/i, '');
    var m = seg.match(/([^\/]+\.(?:jpg|jpeg|png|gif|webp|svg|avif))$/i);
    return m ? m[1] : null;
  }
  function firstFromSrcset(ss) { return ss ? ss.split(',')[0].trim().split(/\s+/)[0] : null; }

  function start(map) {
    function lookup() {
      for (var i = 0; i < arguments.length; i++) {
        var f = fileName(arguments[i]);
        if (f && map[f]) return map[f].url || map[f];
      }
      return null;
    }
    function setAttr(el, a, v) {
      if (v && el.getAttribute(a) !== v) { el.setAttribute(a, v); return true; }
      return false;
    }
    function translateImg(img) {
      var url = lookup(img.getAttribute('src'), img.currentSrc, img.getAttribute('data-src'),
        img.getAttribute('data-photoswipe-src'), firstFromSrcset(img.getAttribute('srcset')),
        firstFromSrcset(img.getAttribute('data-srcset')));
      if (!url) return;
      ['src', 'data-src', 'data-photoswipe-src', 'srcset', 'data-srcset'].forEach(function (a) {
        if (img.hasAttribute(a)) setAttr(img, a, url);
      });
    }
    var running = false;
    function run() {
      if (running) return;
      running = true;
      try {
        document.querySelectorAll('img').forEach(translateImg);
        document.querySelectorAll('a[href*="/cdn/shop/"], a[data-product-thumb]').forEach(function (a) {
          var u = lookup(a.getAttribute('href')); if (u) setAttr(a, 'href', u);
        });
        document.querySelectorAll('[data-photoswipe-src]:not(img)').forEach(function (el) {
          var u = lookup(el.getAttribute('data-photoswipe-src')); if (u) setAttr(el, 'data-photoswipe-src', u);
        });
      } finally { running = false; }
    }
    window.__dsImgTranslate = { run: run, size: Object.keys(map).length };
    function boot() {
      new MutationObserver(run).observe(document.body, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset', 'data-photoswipe-src', 'href']
      });
      run();
      document.addEventListener('change', function (e) {
        if (e.target.matches && e.target.matches('input[type="radio"], select[data-product-select]')) {
          setTimeout(run, 100); setTimeout(run, 400);
        }
      });
      [100, 400, 1000, 2500].forEach(function (d) { setTimeout(run, d); });
      var n = 0, iv = setInterval(function () { run(); if (++n >= 10) clearInterval(iv); }, 3000); // Sicherheitsnetz 30 s
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  }

  fetch(src, { credentials: 'omit' })
    .then(function (r) { return r.json(); })
    .then(function (all) {
      var map = pick(all, lang) || pick(all, lang.split('-')[0]);
      if (map) start(map);
    })
    .catch(function () {});
})();
